@if (!legacyHandoffPending()) {
<!-- v2 owns the whole app: render only the router-outlet, its own splash/shell
     own loading + chrome. While a legacy deep link is being handed off
     (legacyHandoffPending), hold off rendering rather than briefly activating
     whatever route the entry url would otherwise match. -->
<router-outlet />
}
